const BRAND = "Gitcha";
const DEFAULT_TITLE = "Gitcha: The Want Marketplace for Real Estate";
const MAX_DESCRIPTION = 160;

const truncate = (text, max = MAX_DESCRIPTION) => {
  const value = String(text || "").replace(/\s+/g, " ").trim();
  if (value.length <= max) return value;
  return `${value.slice(0, max - 1).trimEnd()}…`;
};

const buildDescription = (adDetails) => {
  const desc = adDetails && adDetails.adDesc ? String(adDetails.adDesc).trim() : "";
  if (desc) return truncate(desc);
  const title = adDetails && adDetails.adTitle ? adDetails.adTitle : "Active buyer demand";
  return truncate(
    `${title}. See this active Want-Listing on ${BRAND}, the buy side of the market.`,
  );
};

export const buildWantAdSeo = (adDetails, { origin = "", pathname = "" } = {}) => {
  const indexable = Boolean(adDetails && adDetails.syndicateToThePublic);
  const title =
    adDetails && adDetails.adTitle ? `${adDetails.adTitle} | ${BRAND}` : DEFAULT_TITLE;
  const description = buildDescription(adDetails);
  const canonical = origin ? `${origin}${pathname || ""}` : "";
  const loaded = Boolean(adDetails);

  return {
    indexable,
    title,
    description,
    canonical,
    robots: loaded ? (indexable ? "index,follow" : "noindex,nofollow") : null,
    ogImage: origin ? `${origin}/logo512.png` : "",
  };
};

export default buildWantAdSeo;
